import styled from "styled-components";

// 최상위 레이아웃
export const Div = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f6f6f6;
  padding: 25px 50px;
  height: 100vh;
`;

// 각 설정 섹션 레이아웃
export const OuterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 20px;
  align-items: start;
  background-color: white;
  border-radius: 4;
  margin-top: 50px;
`;

// 각 설정 섹션 타이틀
export const SmallTitle = styled.span`
  flex-grow: 1;
  font-weight: bold;
  font-size: 18px;
  font-family: "Noto Sans KR";
  max-width: 200px;
`;

// 각 설정 섹션 메뉴
export const InnerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  justify-content: space-between;
  border-left: 1px solid #e8e8e8;
  flex-grow: 2;
`;
